import React from "react";
import { connect } from "react-redux";
import * as actions from "./../../modules/booking/actions";
import { bindActionCreators } from "redux";
import { Calendar, momentLocalizer } from "react-big-calendar";
import moment from "moment";
import withDragAndDrop from "react-big-calendar/lib/addons/dragAndDrop";
// import Bell from "./bell/index.js";
import "react-big-calendar/lib/css/react-big-calendar.css";
import "react-big-calendar/lib/addons/dragAndDrop/styles.scss";
import "./styles.scss";
import CreateDialog from "./dialog/create/index";
import DetailDialog from "./dialog/detail/index";
import Dialog from "../shared/dialog";
import isEmpty from "lodash/isEmpty";
import MyButton from "./../shared/buttons/primary";
import AlertDialog from "./dialog/create-alert";
import { GOURMET, CITY_BOOKING, STANDARD_TABLE } from "../../constants/app";
import useBlockTime from "../../hooks/use-block-times";
import Event from "./components/event";
import CustomToolbar from "./components/toolbar";
import { cloneDeep } from "lodash";
require("moment-timezone");

const DragAndDropCalendar = withDragAndDrop(Calendar);

const formats = {
  timeGutterFormat: "HH:mm",
};

const TODAY = moment(moment().toDate()).format("YYYY-MM-DD");

const GourmetBooking = (props) => {
  const localizer = momentLocalizer(moment);
  const { dispatchActions, setting, booking, auth } = props;
  const { user } = auth;
  const isGourmet = user.category_type === GOURMET;
  const isCityBooking = user.city_name === CITY_BOOKING;
  const bookingTimeBlock = user.booking_time_block;
  const [listBooking, setListBooking] = React.useState([]);
  const [bookingData, setBookingData] = React.useState({});
  const [currentDay, setCurrentDay] = React.useState(
    moment().format("YYYY-MM-DD").toString()
  );
  const [isCreateModalOpen, setIsCreateModalOpen] = React.useState(false);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = React.useState(false);
  const [isAlertModalOpen, setIsAlertModalOpen] = React.useState(false);
  const [deleteBookingId, setDeleteBookingId] = React.useState("");

  const [isDetailModalOpen, setIsDetailModalOpen] = React.useState(false);
  const [chosenStartDate, setChosenStartDate] = React.useState("");
  const [pageShowIsBar, setPageShowIsBar] = React.useState(false);
  const [toggle, setToggle] = React.useState(0);
  const [tableSeatList, setTableSeatList] = React.useState([]);
  const {
    __blockTimes,
    currDay: currDayWorkingHoursRaw,
    workingHours,
  } = useBlockTime(user, currentDay);

  const handleGetListBarSeat = () => {
    window
      .axios({
        url: `/shop/${user.id}/seat/`,
        method: "get",
        params: {
          date: currentDay,
        },
      })
      .then((result) => {
        setTableSeatList(result.data.results);
      });
  };

  // React.useEffect(() => {
  //   if (!plusIconRef.current) return;

  //   const handleClick = (e) => {
  //     e.preventDefault();
  //     setToggle((prev) => (prev === 0 ? 1 : 0));
  //   };

  //   const node = plusIconRef.current;
  //   node.addEventListener("click", handleClick);
  //   node.classList.add("plus-icon");

  //   return () => {
  //     node.removeEventListener("click", handleClick);
  //     node.classList.remove("plus-icon");
  //   };
  // }, []);

  React.useEffect(() => {
    const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
    dispatchActions.setIsMobile(isMobile);
    handleGetListBarSeat();
  }, []);

  React.useEffect(() => {
    handleFetchBookings();
  }, [pageShowIsBar]);

  const handleFetchBookings = React.useCallback(
    async (day) => {
      const result = await window.axios({
        method: "get",
        url: `shop/${user.id}/book/?date=${day || TODAY}`,
      });
      const bookingFiltered = handleFilterBooking(result.data.results);
      if (bookingFiltered.length) {
        const bookingFormatted = formatBooking(bookingFiltered);
        setListBooking(bookingFormatted);
      } else {
        setListBooking([]);
      }
    },
    [pageShowIsBar]
  );

  const formatBooking = (bookings) => {
    let bookingFormatted = [];
    const formatMethod = isGourmet
      ? formatBookingGourmet
      : formatNotBookingGourmet;
    bookings.map((booking) => {
      bookingFormatted.push(...formatMethod(booking));
    });

    return bookingFormatted;
  };

  const getDefaultFormatBooking = (booking) => {
    return {
      title: `${booking.username || booking.user.full_name || ""} - ${
        booking.phone_number || booking.user.phone_number || ""
      }`,
      start: moment(booking.start_time).toDate(),
      end: moment(booking.end_time).toDate(),
    };
  };

  const formatNotBookingGourmet = (booking) => {
    return {
      ...booking,
      ...getDefaultFormatBooking(booking),
      resourceId: booking.staff,
    };
  };

  const formatBookingGourmet = (booking) => {
    const { tables, seats } = booking;
    const listBookingByType = [];
    const resource = seats.length ? seats : tables;
    resource.map((item) => {
      const table = seats.length
        ? {
            ...item,
            name: `${item.seat_name}`,
          }
        : item;
      listBookingByType.push({
        ...booking,
        tables: table,
        resourceId: table.id,
        ...getDefaultFormatBooking(booking),
      });
    });
    return listBookingByType;
  };

  const handleFilterBooking = (bookings) => {
    if (!bookings) return [];
    return bookings.filter((booking) => {
      const isCancel = booking.status !== "cancelled";
      if (!isGourmet) return isCancel && booking.staff;
      else {
        return (
          isCancel &&
          (pageShowIsBar ? booking.seats?.length : booking.tables?.length)
        );
      }
    });
  };

  const handleMove = ({ event, start, end }) => {
    const startFormat = moment(start).format("HH:mm");
    if (__blockTimes.includes(startFormat)) {
      setIsAlertModalOpen(true);
      return;
    }

    const eventCloned = window._.cloneDeep(event);
    eventCloned.start = start;
    eventCloned.end = end;
    const bookingInfo = listBooking.find(
      (booking) => booking.id === eventCloned.id
    );
    setListBooking([
      ...listBooking,
      {
        ...bookingInfo,
        start_time: start,
        end_time: end,
        start,
        end,
      },
    ]);

    handleUpdateBooking(eventCloned.id, {
      end_time: moment(eventCloned.end).format("YYYY-MM-DD HH:mm"),
      start_time: moment(eventCloned.start).format("YYYY-MM-DD HH:mm"),
    });
  };

  const selectEvent = (resource) => {
    if (isGourmet) {
      const bookingClone = cloneDeep(listBooking);
      resource[pageShowIsBar ? "seats" : "tables"] = bookingClone
        .filter((item) => item.id === resource.id)
        .map((item) => {
          return {
            value: item["tables"]?.id,
            label: item["tables"]?.name,
          };
        });
    } else {
      resource["staff"] = resource.resourceId;
    }
    setBookingData(resource);
    setIsDetailModalOpen(true);
  };

  const handleCreateEvent = (resource) => {
    const { start, end, resourceId } = resource;
    const { auth, setting } = props;
    const startTimeFormat = moment(start).format("HH:mm");
    if (!__blockTimes.includes(startTimeFormat)) {
      setChosenStartDate(startTimeFormat);
      setIsAlertModalOpen(true);
      return;
    }

    const bookingData = {
      start_time: start,
      end_time: end,
      shop: auth.user.id,
      listStaff: setting.listStaff,
      listMenu: setting.listMenu,
      listTable: setting.listTable.results,
    };
    if (isGourmet) {
      bookingData["table"] = {
        value: resourceId,
        label: calendarHeaderData.find((item) => item.id === resourceId)?.name,
      };
    } else {
      bookingData["staff"] = resource.resourceId;
    }
    setBookingData(bookingData);
    setIsCreateModalOpen(true);
  };

  const onCalendarNavigate = (date) => {
    dispatchActions.setSimpleCalendarChosenDate(date);
    setCurrentDay(date);
    handleFetchBookings(moment(date).format("YYYY-MM-DD"));
  };

  const closeCreateModal = (data) => {
    setIsCreateModalOpen(false);
    setBookingData({});
    updateBookingList(data);
  };

  const closeDetailModal = (data) => {
    setIsDetailModalOpen(false);
    setBookingData({});
    if (isEmpty(data)) return;
    if (data.status === "cancelled") {
      setListBooking(listBooking.filter((item) => item.id !== data.id));
      return;
    }

    const formatBooking = isGourmet
      ? formatBookingGourmet(data)
      : formatNotBookingGourmet(data);

    setListBooking(
      listBooking.map((booking) => {
        if (booking.id === formatBooking.id) return formatBooking;
        return booking;
      })
    );
  };

  const onDeleteBooking = ({ id }) => {
    setIsDeleteModalOpen(true);
    setDeleteBookingId(id);
  };

  const handleDeleteBooking = async () => {
    const result = await window
      .axios({
        url: `booking/${deleteBookingId}/`,
        method: "delete",
      })
      .then((result) => {
        if (result.status === 204) {
          setListBooking(
            listBooking.filter((item) => item.id !== deleteBookingId)
          );
          setDeleteBookingId("");
        }
      });
    return result;
  };

  const closeDeleteModal = async (type) => {
    if (type === 1) {
      await handleDeleteBooking();
    }
    setIsDeleteModalOpen(false);
  };

  const updateBookingList = (booking) => {
    if (isEmpty(booking) || booking.status === "cancelled") return;
    const formattedBooking = formatBooking([booking]);
    setListBooking([...listBooking, ...formattedBooking]);
  };

  const handleUpdateBooking = (bookingId, payload) => {
    window.axios({
      url: `booking/${bookingId}/`,
      method: "patch",
      data: {
        id: bookingId,
        ...payload,
      },
    });
  };

  const renderWaringContent = React.useMemo(() => {
    const isShowWarning = !booking.isMobile && booking.warningHasShown;
    if (!isShowWarning) return null;
    return (
      <div className="booking__warning-content">
        <p>
          予約カレンダーはモバイルプラットフォームでは完全にはサポートされていません。最高のエクスペリエンスを得るにはコンピューターをご利用ください。
        </p>
        <div className="booking__warning-button">
          <MyButton
            myVariant="create"
            onClick={() => {
              dispatchActions.setWarningShowState(true);
            }}
          >
            閉じる
          </MyButton>
        </div>
      </div>
    );
  }, [booking]);

  const calendarHeaderData = React.useMemo(() => {
    let data = [];
    if (isGourmet) {
      if (pageShowIsBar) {
        data = tableSeatList.map((seat) => {
          return {
            ...seat,
            name: seat.seat_name,
          };
        });
      } else {
        data = setting.listTable.results.filter(
          (table) => table.table_type === STANDARD_TABLE
        );
      }
    } else {
      data = setting.listStaff;
    }

    return data;
  }, [isGourmet, setting, pageShowIsBar]);

  const min = React.useMemo(() => {
    let day = workingHours.start;
    if (toggle) {
      day = moment(currentDay).startOf("day");
    }
    return moment(day).toDate();
  }, [toggle, currentDay, workingHours]);

  const max = React.useMemo(() => {
    let day = workingHours.end;
    if (toggle) {
      day = moment(currentDay).endOf("day");
    }
    return moment(workingHours.end).toDate();
  }, [toggle, currentDay, workingHours]);

  const hideCalendar = (node) => {
    if (node.style.visibility !== "hidden") {
      node.style.visibility = "hidden";
      node.style.opacity = "0";
    }
  };
  const showCalendar = (node) => {
    if (node.style.visibility !== "visible") {
      node.style.visibility = "visible";
      node.style.opacity = "1";
    }
  };

  const slotPropGetter = (date) => {
    const node = document.querySelector(".rbc-time-view");
    let backgroundColor, borderTop, cursor;

    if (!workingHours.isWorkingDay) {
      if (node) {
        hideCalendar(node);
      }
    } else {
      if (node) {
        showCalendar(node);
      }
      if (!__blockTimes.includes(moment(date).format("HH:mm"))) {
        backgroundColor = "#cdcdcd";
        borderTop = "0";
      }
    }

    const style = {
      backgroundColor,
      borderTop,
      cursor,
    };
    return {
      style: style,
    };
  };

  const renderBook = ({ event }) => {
    return (
      <div className="rbc-day-bg">
        <button>Book Class</button>
      </div>
    );
  };

  const resizeEvent = ({ end, start, event, resourceId }) => {
    // const { events } = this.state;
    // const nextEvents = events.map((existingEvent) => {
    //   return existingEvent.id == event.id
    //     ? { ...existingEvent, start, end }
    //     : existingEvent;
    // });
    // this.setState({
    //   events: nextEvents,
    // });
  };

  const handleChangePageMode = (value) => {
    setPageShowIsBar(value);
  };

  const renderToolbar = (rest) => {
    return (
      <CustomToolbar
        {...rest}
        {...props}
        isGroumet={isGourmet && isCityBooking}
        onChangePageMode={handleChangePageMode}
        pageShowIsBar={pageShowIsBar}
      />
    );
  };

  const renderCalendar = React.useCallback(() => {
    return (
      <DragAndDropCalendar
        id="booking-calendar"
        selectable
        localizer={localizer}
        events={listBooking}
        onEventDrop={handleMove}
        resizable
        onSelectEvent={selectEvent}
        onSelectSlot={handleCreateEvent}
        min={min}
        max={max}
        resources={calendarHeaderData.map((item) => ({
          resourceId: item.id,
          resourceTitle: item.name,
        }))}
        slotPropGetter={slotPropGetter}
        onNavigate={onCalendarNavigate}
        resourceIdAccessor="resourceId"
        resourceTitleAccessor="resourceTitle"
        onEventResize={resizeEvent}
        defaultView="day"
        views={["day"]}
        step={isCityBooking ? bookingTimeBlock : 30}
        timeslots={1}
        showMultiDayTimes={true}
        defaultDate={currentDay}
        formats={formats}
        // longPressThreshold={10}
        components={{
          timeGutterColumn: () => null,
          event: (event) => <Event {...event} onDelete={onDeleteBooking} />,
          toolbar: (rest) => renderToolbar(rest),
          dateCellWrapper: renderBook,
        }}
      />
    );
  }, [listBooking, calendarHeaderData, pageShowIsBar, min, max]);

  return (
    <div id="booking" className="booking">
      <div className="booking__warning">{renderWaringContent}</div>
      <div className="booking__big-calendar">
        {!calendarHeaderData.length ? (
          <h2 className="booking__no-staff-announce">
            {isCityBooking && isGourmet
              ? "座席が居ません!"
              : `${
                  window.store.getState().auth.user.section_name_1
                }が居ません!`}
          </h2>
        ) : !setting.listMenu?.length ? (
          <h2 className="booking__no-staff-announce">
            {isGourmet ? "コース" : "メニュー"}が有りません!
          </h2>
        ) : (
          renderCalendar()
        )}

        {!workingHours.isWorkingDay ? (
          <div className="booking__not-woring-day-announce">
            <h2>定休日</h2>
          </div>
        ) : (
          ""
        )}
      </div>

      {isCreateModalOpen && (
        <CreateDialog
          isShow={isCreateModalOpen}
          onClose={closeCreateModal}
          data={bookingData}
          blockTimes={__blockTimes}
          calendarHeaderData={calendarHeaderData}
          type={pageShowIsBar}
          {...props}
        />
      )}
      {isDetailModalOpen && (
        <DetailDialog
          onClose={closeDetailModal}
          data={bookingData}
          blockTimes={__blockTimes}
          calendarHeaderData={calendarHeaderData}
          type={pageShowIsBar}
          {...props}
        />
      )}
      {isAlertModalOpen ? (
        <AlertDialog
          chosenStartDate={chosenStartDate}
          currDayWorkingHours={currDayWorkingHoursRaw}
          onClose={() => {
            setIsAlertModalOpen(false);
          }}
        />
      ) : (
        ""
      )}
      {isDeleteModalOpen && (
        <Dialog
          title={"削除"}
          isShow={isDeleteModalOpen}
          onCloseRequest={() => closeDeleteModal(0)}
          closeOnOverlayClick={true}
          className={"custom-delete-dialog"}
        >
          <span
            type="button"
            className="detail-button me-3"
            onClick={() => closeDeleteModal(0)}
          >
            キャンセル
          </span>
          <span
            type="button"
            className="delete-button"
            onClick={() => closeDeleteModal(1)}
          >
            削除
          </span>
        </Dialog>
      )}
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    booking: state.booking,
    auth: state.auth,
    setting: state.setting,
  };
};

const mapDispatchToProps = (dispatch) => ({
  dispatchActions: bindActionCreators({ ...actions }, dispatch),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(React.memo(GourmetBooking));
